import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { isNil } from 'lodash-es';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { InvitationStatusType, UserRoleType } from '@vi-iot/client';

import { getViewportHeight } from '@common';
import { GTMService } from '@services';
import { AuthStore, GatewayInvitationsState, MeUserDetails, SearchType } from '@store';

import { GatewayInvitationsService } from '../../../../+installations/installation/gateway-features-panel/gateway-invitations.service';

@Component({
  selector: 'app-invitations-search-results',
  templateUrl: './invitations-search-results.component.html',
  styleUrls: ['./invitations-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationsSearchResultsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Output() fetchNext = new EventEmitter();
  @Input() companyNumber: string;

  invitationState$: Observable<GatewayInvitationsState>;
  searchType$ = new BehaviorSubject(SearchType.gatewayInvitations);
  me$: Observable<MeUserDetails>;

  getViewportHeight = getViewportHeight;
  statusFilters: { value: string; name: string }[];
  status: InvitationStatusType | '';
  userRoleType = UserRoleType;
  initialFilter = '';
  nextBatch = false;
  itemSize = 75;
  limit = 50;

  constructor(
    private gatewayInvitationsService: GatewayInvitationsService,
    private gtmService: GTMService,
    private authStore: AuthStore
  ) {}

  ngOnInit(): void {
    this.invitationState$ = this.gatewayInvitationsService.selectInvitations();
    this.statusFilters = this.gatewayInvitationsService.statusFilters;
    this.me$ = this.authStore.getMe();
  }

  onFetchNext(next: { offset?: number; limit: number; cursor?: string }): void {
    if (this.companyNumber) {
      this.listGatewayInvitations(next.offset);
    }
  }

  onNextBatchChange($event: boolean): void {
    this.fetchNext.emit();
    this.nextBatch = $event;
  }

  onFilterChange(status: InvitationStatusType): void {
    this.status = status;
    this.gatewayInvitationsService.filterByStatus({
      customerNumber: this.companyNumber,
      limit: this.limit,
      offset: 0,
      status,
    });
    this.gtmService.track('onSelect', `${status} invitation status filter`, 'Invitation list');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.gatewayInvitationsService.clearStore();
  }

  allowedSupporterRole(role: UserRoleType): boolean {
    if (isNil(role)) {
      return false;
    }

    return (
      role !== this.userRoleType.supportLocalReadOnly &&
      role !== this.userRoleType.supportLocalReadWrite &&
      role !== this.userRoleType.supportLocalReadWriteWithRemoteDiagnosis &&
      role !== this.userRoleType.supportLocalDepartmentManagement
    );
  }

  private listGatewayInvitations(offset?: number): void {
    this.gatewayInvitationsService.listGatewayInvitations({
      customerNumber: this.companyNumber,
      offset: offset || 0,
      status: this.status || null,
      limit: this.limit,
    });
  }
}
